import {
  CalendarDaysIcon,
  ClockIcon,
  ComputerDesktopIcon,
  HomeModernIcon,
  ShoppingBagIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import { BiSolidUserDetail } from "react-icons/bi";
import { FaUserDoctor, FaWpforms } from "react-icons/fa6";
import { GrDocumentTest } from "react-icons/gr";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdOutlineLoyalty, MdOutlineVaccines, MdOutlineWorkHistory, MdPayment } from "react-icons/md";
import { PiCertificateBold, PiUserListLight } from "react-icons/pi";
import { HiOutlineBellAlert } from "react-icons/hi2";
import { CiViewList } from "react-icons/ci";
import { IoFlaskOutline } from "react-icons/io5";

export const useUIIcons = () => {
  const icons = {
    CUSTOMER_PROFILE_TAB_ICONS: {
      /* Match with Ids of customer profile headers */
      APPOINTMENTS_TAB: <BiSolidUserDetail />,
      EMR_TAB: <FaUserDoctor />,
      VACCINATION_TAB: <MdOutlineVaccines />,
      MEDICINE_HISTORY: <MdOutlineWorkHistory />,
      LAB_TEST_TAB: <GrDocumentTest />,
      LAB_INTERPRETATION_TAB: <IoFlaskOutline />,
      CERTIFICATES_TAB: <PiCertificateBold />,
      INVOICE_TAB: <MdPayment />,
      TICKECT_TAB: <CiViewList />,
      MEMBERSHIP_DETAILS_TAB: <MdOutlineLoyalty />,
      REMINDERS_TAB: <HiOutlineBellAlert />,
      FORM_TAB: <FaWpforms />,
      OTHER_INFORMATION_TAB: <IoMdInformationCircleOutline />,
    },
    NAV_ICONS: {
      DASHBOARD: <HomeModernIcon className="w-4 h-4" />,
      CUSTOMER_PROFILE: <UserCircleIcon className="w-4 h-4" />,
      APPOINTMENTS: <ClockIcon className="w-4 h-4" />,
      ROTA: <ComputerDesktopIcon className="w-4 h-4" />,
      PATIENT_WAITING_LIST: <IoFlaskOutline />,
      AT_HOME_SERVICES: <IoFlaskOutline />,
      LAB_REPORT: <PiUserListLight />,
      STAFF_CALENDAR: <CalendarDaysIcon className="w-4 h-4" />,
      ORDER_MANAGEMENT: <ShoppingBagIcon className="w-4 h-4" />,
    },
  };
  return icons;
};
